<template>
  <b-container>
    <b-row>
      <b-col>
        <highcharts :key="hcKey" :options="chartOptions"></highcharts>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { setChartMenuItemsLang } from '../../../utils/formatter'
export default {
  name: 'riy-at-rhp-chart',
  props: {
    value: {},
    title: {},
  },
  data() {
    return {
      hcKey: 0,
    }
  },
  computed: {
    chartOptions: function () {
      var vueThis = this
      return {
        lang: this.setOptions,
        chart: {
          type: 'columnrange',
          zoomType: 'xy',
          backgroundColor: '#FFFFFF',
          height: '50%',
        },
        title: {
          text: this.title,
          style: { fontSize: '25px', fontWeight: 'bold' },
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          gridLineWidth: 2,
          labels: {
            rotation: -30,
          },
          categories: this.value
            ? this.value.sort((a, b) => (a.issuerName > b.issuerName ? 1 : -1)).map((el) => el.issuerName)
            : [],
        },
        yAxis: {
          title: {
            text: 'RIY',
          },
          min: 0,
          labels: {
            formatter: (val) => this.$n(val.value, 'percent'),
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              '<b class="hc-tooltip-title">' +
              this.point.name +
              '</b><br>' +
              '<b>Prod</b>: ' +
              this.point.meta.productCount +
              '<br>' +
              '<b>' +
              vueThis.$t('search.resultTable.riyMin') +
              '</b>: ' +
              vueThis.$n(this.point.low, 'percent') +
              '<br>' +
              '<b>' +
              vueThis.$t('search.resultTable.riyMax') +
              '</b>: ' +
              vueThis.$n(this.point.high, 'percent')
            )
          },
        },
        legend: {
          enabled: false,
        },
        series: [
          {
            name: '',
            colorByPoint: true,
            data: this.chartData,
            minPointLength: 3,
          },
        ],
      }
    },
    chartData: function () {
      {
        if (this.value.length === 0) {
          return []
        }
        return this.value.map((el) => {
          return {
            low: el.riyMin,
            high: el.riyMax,
            name: el.issuerName,
            meta: {
              productCount: el.productsCount,
            },
          }
        })
      }
    },
    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
}
</script>
<style lang="scss" scoped>
input:not([type='checkbox']),
select {
  width: 100%;
}

input:not([type='checkbox']),
select {
  width: 100%;
}

#optTabChart label {
  border: 0px;
  background-color: transparent !important;
  color: gray;
  box-shadow: none;
  padding: 1rem 0rem 0rem 1rem;
}
</style>
